import { DescribeChangeSetOutput } from "@aws-sdk/client-cloudformation";
import CustomDataGrid from "@components/common/DataGrid/CustomDataGrid";
import { Chip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";

const ChangesetDetails = ({ loading, data }: { loading: boolean; data: DescribeChangeSetOutput["Changes"] }) => {
  const columns: GridColDef[] = [
    {
      field: "Action",
      headerName: "Action",
      flex: 1,
      renderCell: ({ value }) => renderActionCell(value),
    },
    { field: "LogicalResourceId", headerName: "Logical ID", flex: 1 },
    { field: "ResourceType", headerName: "Resource Type", flex: 1 },
    { field: "Replacement", headerName: "Replacement", flex: 1 },
    { field: "PolicyAction", headerName: "Policy Action", flex: 1 },
    { field: "PhysicalResourceId", headerName: "Physical ID", flex: 1 },
  ];

  const rows =
    data?.map((row, index) => ({
      id: index,
      Action: row.ResourceChange?.Action,
      LogicalResourceId: row.ResourceChange?.LogicalResourceId,
      ResourceType: row.ResourceChange?.ResourceType,
      Replacement: row.ResourceChange?.Replacement,
      PolicyAction: row.ResourceChange?.PolicyAction,
      PhysicalResourceId: row.ResourceChange?.PhysicalResourceId,
    })) || [];

  return (
    <CustomDataGrid
      defaultHeight="100%"
      hideHeaders={loading || !data?.length}
      hideFooter={true}
      loading={loading}
      style={{ width: "100%", height: "90%" }}
      rows={rows}
      columns={columns}
      autoPageSize
      disableRowSelectionOnClick
      noRowsOverlayProps={{ description: "No changesets selected" }}
      disableColumnResize={false}
    />
  );
};

function renderActionCell(value: any) {
  const backgroundColors: Record<string, string> = {
    Add: "#107145", // Green
    Remove: "#bf260e", // Red
    Modify: "#0048e3", // Blue
  };

  const style = {
    backgroundColor: backgroundColors[value] || "grey",
    color: "white",
  };
  return <Chip label={value} style={style} />;
}

export default ChangesetDetails;
